module.exports = {
          srcSet: __webpack_public_path__ + "public/55071fec5c2f2abbed0a0dc0726b83e5-1024.png"+" 1024w",
          images:[ {path: __webpack_public_path__ + "public/55071fec5c2f2abbed0a0dc0726b83e5-1024.png",width: 1024,height: 1024}],
          src: __webpack_public_path__ + "public/55071fec5c2f2abbed0a0dc0726b83e5-1024.png",
          toString:function(){return __webpack_public_path__ + "public/55071fec5c2f2abbed0a0dc0726b83e5-1024.png"},
          
          width: 1024,
          height: 1024
        }